/* import __COLOCATED_TEMPLATE__ from './news-center.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();